// ================================================================================
// front-page.js
// TOP 用のスクリプトファイル
// ================================================================================

// News Tab
// --------------------------------------------------------------- //

export default function career() {

	let floating = document.getElementById('js-career-floating');

	function floatingView() {
		let floating = document.getElementById('js-career-floating');
		let start = 100;
		let height = window.innerHeight;
		let ctaPos = document.getElementById('js-career-action').getBoundingClientRect().top;
		let triggerPos = ctaPos + height;

		let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
		let currentPos = scrollTop;

		if ( currentPos > start && triggerPos > currentPos ) {
			floating.classList.add('is-active');
		} else {
			floating.classList.remove('is-active');
		}

	}

	if ( floating ) {

		['load', 'resize', 'scroll'].forEach(function (e) {
			window.addEventListener(e, floatingView);
		});

	}

}
